import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/applicationInfo/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/applicationInfo/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/applicationInfo/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/applicationInfo/updateById', data)
}

// 修改状态
export function updateStatus (data) {
  return request.post('/business/applicationInfo/updateStatus', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/applicationInfo/delete/${id}`)
}

// 根据ID查询
export function getById (id) {
  return request.get(`/business/applicationInfo/${id}`)
}

